/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-debugger,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import vasActivationModalTemplate from '../SavedWithSuccessModal.html';


class MessageOutboundDetailsController {

  /* @ngInject */

  constructor($log, $q, $timeout, MerchantConfigurationService,
              MerchantVasService, StorageService, ModalFactory, TermsService,
              NewTokenService) {
    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['MESSAGE-OUTBOUND'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');

    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };


    const save = () => {
      MerchantVasService.configureVas( that.currentVas.configuration, that.currentVas.id);
    };

    const init = () => {
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );
    };

    that.$onInit = init;


  }

}

export default MessageOutboundDetailsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/messageOutbound/messageOutbound.controller.js
 **/